<template>
  <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

